export default "__VITE_ASSET__r9JC0dlw__"